import { useState } from 'react';
import useMountEffect from 'hooks/useMountEffect';
import api from 'api';
import { CONFIG } from 'utils/config';
import { log } from 'utils';
import { EventIds } from '../../constants/eventIds';

export const useGetIsGDPR = () => {
    const [isGdpr, setIsGdpr] = useState(false);

    async function getGeolocation() {
        try {
            const response = await api.get<{ data: { isGdpr: boolean } }>(
                CONFIG.VITE_MS_GEOLOCATION,
            );

            setIsGdpr(!!response.data?.data?.isGdpr);
        } catch (error) {
            log.error(
                'useGetIsGDPR error',
                EventIds.FailedToGetGeolocation,
                error,
            );
        }
    }

    useMountEffect(getGeolocation);

    return isGdpr;
};
